const request = {
    invalid_input: 'الإدخال غير صالح. {{details}}',
    general: 'حدث خطأ في الطلب.',
};
export default Object.freeze(request);
